import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  translationSelector,
  fetchTranslationsList,
} from "slices/translationSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { removeTranslation, removeTranslationFromStore } from "slices/translationSlice";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import CotationPopup from "./CotationPopup";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import { languageSelector } from "slices/languageSlice";
import ErrorMessage from "components/common/ErrorMessage";
import { fetchLanguages } from "slices/languageSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import transicon from "../../assets/img/transicon.png";
import transicon2 from "../../assets/img/transicon2.png";
import transicon3 from "../../assets/img/transicon3.png";
import transicon4 from "../../assets/img/transicon4.png";
import { LegendButton } from "components/common/TableColor";
import { filteredStatuses } from "components/common/TableColor";
import { fetchClients } from "slices/ClientNameSlice";
import { fetchTranslators } from "slices/TranslatorNameSlice";
import { fetchClientsPaginated } from "slices/ClientNameSlice";

function Translation({ item }) {
  const [cotationPopup, setCotationPopup] = React.useState({
    open: false,
    documents: [],
  });
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const {
    translations,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
    paramStatus,
  } = useSelector(translationSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {},
  });
  const refAddutton = React.useRef(null);
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [translationPageLength, setTranslationPageLength] = useState(10);
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "id",
    sortDirection: "desc",
  });
  const { language: languages } = useSelector(languageSelector);
  const { clients, error } = useSelector((state) => state?.clients);
  const { translators } = useSelector((state) => state.translators);
  const [status, setStatusValue] = React.useState("all");

  const handleAddLanguagePopUp = () => {
    setTimeout(() => {
      navigate("/translation/create");
    }, 300);
  };

  const submitCallback = (ok, message) => {
    if (ok) {
      toast.success(message, {
        className: "successToast",
      });
      setSelectedItems([]);
      setSelectAll(false);

      // Build params from current filters, sort and search so the list
      // refreshes preserving the current view after delete
      const values = getValues();
      const params = {
        start_date: values.start_date || moment().format("YYYY/MM/DD"),
        end_date: values.end_date || moment().format("YYYY/MM/DD"),
        status: status === "all" ? undefined : status,
        translator: values.translator ?? null,
        client: values.client ?? null,
        source_language: values.source_language ?? null,
        target_language: values.target_language ?? null,
        sortBy: sortConfig?.sortBy,
        sortDirection: sortConfig?.sortDirection,
        search: searchTerm || undefined,
      };

      Object.keys(params).forEach((key) => {
        if (params[key] === null || params[key] === "" || params[key] === undefined) {
          delete params[key];
        }
      });

      dispatch(fetchTranslationsList(currentPage, params));
      hideConfirmDialog();
    } else {
      toast.error(message, {
        className: "errorToast",
      });
    }
  };



  const [option, setOption] = useState([]);


  const clientsLoadOptions = async (inputValue, loadedOptions, { page }) => {
    try {
      const result = await dispatch(
        fetchClientsPaginated({
          page,
          pageLength: 20,
          search: inputValue,
        })
      );

      const data = result?.data?.data || [];
      const lastPage = result?.data?.last_page || 1;

      const newOptions = data.map(c => ({ value: c.id, label: c.name }));
      setOption((prev) => [...prev, ...newOptions]);

      return {
        options: newOptions,
        hasMore: page < lastPage,
        additional: { page: page + 1 },
      };
    } catch (error) {
      console.error(error);
      return { options: [], hasMore: false, additional: { page } };
    }
  };







  const showConfirmDialog = () => {
    setDeleteModal(true);
    return;
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  };
  const handleRemoveItems = () => {
    if (!selectedItems || selectedItems.length === 0) return;

    // Optimistically remove from store so UI updates immediately
    dispatch(removeTranslationFromStore(selectedItems));
    // Clear UI selection and close modal right away
    setSelectedItems([]);
    setSelectAll(false);
    hideConfirmDialog();

    // Call API for each item; if any fail, refetch the list to restore state
    const ids = [...selectedItems];
    let remaining = ids.length;
    const failures = [];

    const values = getValues();
    const baseParams = {
      start_date: values.start_date || moment().format("YYYY/MM/DD"),
      end_date: values.end_date || moment().format("YYYY/MM/DD"),
      status: status === "all" ? undefined : status,
      translator: values.translator ?? null,
      client: values.client ?? null,
      source_language: values.source_language ?? null,
      target_language: values.target_language ?? null,
      sortBy: sortConfig?.sortBy,
      sortDirection: sortConfig?.sortDirection,
      search: searchTerm || undefined,
    };

    Object.keys(baseParams).forEach((key) => {
      if (baseParams[key] === null || baseParams[key] === "" || baseParams[key] === undefined) {
        delete baseParams[key];
      }
    });

    ids.forEach((id) => {
      dispatch(
        removeTranslation(id, (ok, message) => {
          remaining -= 1;
          if (!ok) failures.push(message || "Failed to delete");

          if (remaining === 0) {
            if (failures.length > 0) {
              toast.error(failures.join(", "), {
                className: "errorToast",
              });
              // restore state from server
              dispatch(fetchTranslationsList(currentPage, getAllFilters()));
            } else {
              toast.success("Deleted successfully", { className: "successToast" });
              // keep current view; optionally refresh to ensure consistency
              dispatch(fetchTranslationsList(currentPage, getAllFilters()));
            }
          }
        })
      );
    });
  };
  const handleChange = (e) => {
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item != id)
        : [...selectedItems, id]
    );
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
      return;
    }
    setSelectAll(true);
    setSelectedItems(
      translations?.map((translation) => translation.id.toString())
    );
  };



  const handleClose = () => {
    refAddutton.current.click();
    setAddForm({ show: false });
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
  };

  //#region TABLE HEAD

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      const params = getAllFilters();
      dispatch(fetchTranslationsList(currentPage, params));

    };
    return (
      <tr>
        <th className="table-col">#</th>
        <th className="table-col">TransID</th>
        <th className="table-col">Account</th>
        <th className="table-col">Source</th>
        <th className="table-col">Target</th>
        <th className="table-col">Requester</th>
        <th className="table-col">Status</th>
        <th className="table-col">Total Words Count</th>
        {/* <th className="col-2">Est. Words Count</th> */}
        <th className="table-col">Total Amount</th>
        <th className="table-col">Received Date</th>
        {/* {checkPermission("Edit Translations") && (
          <th className="table-col">Details</th>
        )} */}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion

  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);
  const {
    clearErrors,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    getValues,
    setError: setErrors,
    reset,
  } = useForm({
    defaultValues: {
      start_date: moment().format("YYYY/MM/DD"),
      end_date: moment().format("YYYY/MM/DD"),
      translator: null,
      client: null,
      source_language: null,
      target_language: null,
    },
  });

  const getAllFilters = () => {
    const values = getValues();

    const params = {
      start_date: values.start_date || moment().format("YYYY/MM/DD"),
      end_date: values.end_date || moment().format("YYYY/MM/DD"),
      status: status === "all" ? undefined : status,
      translator: values.translator ?? null,
      client: values.client ?? null,
      source_language: values.source_language ?? null,
      target_language: values.target_language ?? null,
      sortBy: sortConfig?.sortBy,
      sortDirection: sortConfig?.sortDirection,
      // search: searchTerm || undefined,
    };

    Object.keys(params).forEach((key) => {
      if (!params[key]) delete params[key];
    });

    return params;
  };


  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    const params = getAllFilters();
    dispatch(fetchTranslationsList(page, params));
  }, [getValues, sortConfig, searchTerm, status]);

  //#region TABLE BODY
  const renderTableContent = React.useCallback(() => {
    const safeTranslations = Array.isArray(translations?.data)
      ? translations.data
      : [];
    return safeTranslations.map((translation, index) => (
      <TranslationItem
        translation={translation}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddLanguagePopUp}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
        onReviseQoute={() => {
          setCotationPopup({
            open: true,
            documents: translation.documents || [
              {
                name: "01091_1560_1771_1680.pdf / Afrikaans",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
              {
                name: "01091_1560_1771_1680.pdf / Berber",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
              {
                name: "01091_1560_1771_1680.pdf / Egyptian Arabic",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
            ],
            transId: translation.id,
          });
        }}
      />
    ));
  }, [translations, selectedItems]);

  // #region Language dropdown
  const filteredLanguages = React.useMemo(
    () =>
      languages?.map((language) => {
        const object = {
          value: language?.id,
          label: language?.name,
        };
        return object;
      }),
    [languages]
  );

  // Source Language
  const [sourceLanguageState, setSourceLanguageState] = React.useState([]);

  React.useEffect(() => {
    const formValue = getValues("source_language_id");
    if (formValue && Array.isArray(formValue) && formValue.length > 0) {
      setSourceLanguageState(
        languages
          ?.filter((lang) => formValue.includes(lang.id))
          ?.map((val) => ({
            label: val?.name || "",
            value: val?.id || "",
          }))
      );
    }
  }, [languages, getValues]);

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "desc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page ? true : false,
      additional: {
        page: page + 1,
      },
    };
  };

  const [targetLanguageState, setTargetLanguageState] = React.useState([]);
  const [activeLegend, setActiveLegend] = React.useState(0);

  const values = getValues();

  const hanldeActiveLegend = (id, value) => {
    setActiveLegend(id);
    setStatusValue(value);

    const values = getValues();
    const params = {
      ...getAllFilters(),
      status: value,
      pagelength: translationPageLength
    };

    dispatch(fetchTranslationsList(1, params));
  };

  React.useEffect(() => {
    dispatch(fetchTranslationsList(1, values));
  }, [dispatch]);


  React.useEffect(() => {
    setTargetLanguageState(
      item?.languages?.map((val) => ({
        label: val?.language?.name || "",
        value: val?.language?.id || "",
      }))
    );
  }, [item?.languages]);

  //#endregion

  // Translation Cards
  const renderCards = () => {
    return (
      <>
        {/* Cards Section  */}
        <div className="d-flex w-100 gap-3 interpreter_translations_boxes" style={{ marginTop: "14px" }}>
          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Total Translations</span>
              <img style={{ width: 24 }} src={transicon} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.total}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Under Review</span>
              <img style={{ width: 24 }} src={transicon2} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.under_review}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Completed</span>
              <img style={{ width: 24 }} src={transicon3} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.completed}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Cancelled</span>
              <img style={{ width: 24 }} src={transicon4} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.cancelled}
            </span>
          </div>
        </div>
      </>
    );
  };

  const filteredStatus = React.useMemo(() => {
    const temp_array = [...filteredStatuses];
    temp_array.unshift({
      value: "all",
      name: "All",
      id: 0,
      color: "#3176A0",
    });
    return temp_array;
  }, [filteredStatuses]);

  React.useEffect(() => {
    dispatch(fetchClients()); // API call for Clients
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(fetchTranslators()); // API call for Translators
  }, [dispatch]);

  // translator Option
  const translatorOptions = React.useMemo(
    () =>
      translators?.data?.map((t) => ({
        value: t.id,
        label: t.first_name || t.name || "Unknown",
      })),
    [translators]
  );

  const translatorLoadOptions = async (search) => {
    const q = (search || "").toLowerCase();
    const filtered = translatorOptions.filter((opt) =>
      opt.label.toLowerCase().includes(q)
    );
    return { options: filtered, hasMore: false };
  };

  // Client Option
  const options = React.useMemo(
    () => clients?.data?.map((c) => ({ value: c.id, label: c.name })),
    [clients]
  );

  const loadOptions = async (search) => {
    const filtered = options.filter((opt) =>
      opt.label.toLowerCase().includes(search.toLowerCase())
    );
    return {
      options: filtered,
      hasMore: false,
    };
  };

  // Filters onsubmit
  const onSubmit = (values) => {
    const params = {
      start_date: values.start_date
        ? moment(values.start_date).format("YYYY/MM/DD")
        : null,
      end_date: values.end_date
        ? moment(values.end_date).format("YYYY/MM/DD")
        : null,
      translator: values.translator ?? null,
      client: values.client ?? null,
      source_language: values.source_language ?? null,
      target_language: values.target_language ?? null,
      status: status ?? null,
    };

    Object.keys(params).forEach((key) => {
      if (!params[key]) delete params[key];
    });

    dispatch(fetchTranslationsList(1, {
      ...getAllFilters(),
      pagelength: translationPageLength
    }));
  };

  console.log("status", status)
  // Reset function
  const handleResetFields = () => {
    const today = moment().format("YYYY/MM/DD");

    reset({
      start_date: today,
      end_date: today,
      client: null,
      translator: null,
      source_language: null,
      target_language: null,
    });

    setTargetLanguageState(null);
    setSourceLanguageState(null);

    // Pass today as start_date and end_date
    dispatch(
      fetchTranslationsList(1, {
        start_date: today,
        end_date: today,
      })
    );
  };


  // Filter section
  const renderFilters = () => {
    return (
      <>
        <div className="container-fluid">
          {/* Row 1 */}
          <div className="d-flex justify-content-start flex-wrap mb-4">
            {/* Status */}
            <LegendButton
              activeId={activeLegend}
              options={filteredStatus}
              handleClick={hanldeActiveLegend}
            />
          </div>

          {/* Row 2 */}
          <div className="row gx-4 gy-3 align-items-center">
            {/* Start Date */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Start Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="start_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={startDateRef}
                        id="start_date"
                        type="date"
                        name="start_date"
                        placeholder="Start Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD") // fallback current date
                        }
                        onChange={(e) => {
                          const dateString = moment(
                            new Date(e.target.value)
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* End Date */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                End Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="end_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={endDateRef}
                        type="date"
                        name="end_date"
                        placeholder="End Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD")
                        }
                        onChange={(e) => {
                          const dateString = moment(
                            new Date(e.target.value)
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Interpreter */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Translator
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="translator"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={
                          field.value
                            ? translatorOptions.find(
                              (opt) =>
                                String(opt.value) === String(field.value)
                            )
                            : null
                        }
                        loadOptions={translatorLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => field.onChange(obj?.value ?? null)}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Row 3 */}
            {/* Clients */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Clients
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="client"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      value={
                        field.value
                          ? options.find((opt) => opt.value === field.value)
                          : null
                      }
                      loadOptions={clientsLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(obj) => field.onChange(obj?.value ?? null)}
                      additional={{ page: 1 }}
                    />
                  )}
                />
              </div>
            </div>

            {/* Source Language */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Source Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="source_language"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{
                            ...selectCustomStyles,
                          }}
                          value={sourceLanguageState}
                          loadOptions={filteredLanguagesLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(selected) => {
                            setSourceLanguageState(selected);
                            field.onChange(selected ? selected.value : null);
                          }}
                          additional={{
                            page: 1,
                          }}
                        />
                      </div>
                      {errors?.source_language_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage
                            text={errors?.source_language_id?.message}
                          />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Target Language */}
            <div className="col-12 col-md-6 col-xl-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Target Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="target_language"
                  control={control}
                  // rules={{ required: "Language must be specified" }}
                  defaultValue={null} // important for single-select
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={targetLanguageState} // should be a single option object or null
                        loadOptions={filteredLanguagesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(selected) => {
                          // selected is an object or null in single-select mode
                          setTargetLanguageState(selected);
                          field.onChange(selected ? selected.value : null);
                        }}
                        onBlur={field.onBlur}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          </div>

          {/* Buttons row */}
          <div className="row-primary btns_area row_10 mb-0">
            <SubmitButton
              handleSubmit={() => handleSubmit(onSubmit)()}
              buttonType="button"
              btnText="Search"
              className={"green"}
            />
            <SubmitButton
              buttonType="button"
              className={"lightBlue"}
              btnText="Reset"
              handleSubmit={handleResetFields}
            />
          </div>
        </div>
      </>
    );
  };

  const fetchList = React.useCallback(
    (page, params) => async (dispatch) => {
      dispatch(fetchTranslationsList(page, params));
    },
    []
  );

  //#endregion

  return (
    <>
      <ListLayout
        heading="Translations"
        time={true}
        title=""
        buttonTitle="Add Translation"
        renderTableHeader={renderTableHeader}
        addButtonDisabled={!checkPermission("Add Translations")}
        renderFilters={renderFilters}
        renderCards={renderCards}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        fetchList={fetchList}
        selectedItems={selectedItems}
        handleRemoveItems={handleRemoveItems}
        renderAddForm={null}
        paginationParams={getAllFilters()}
        renderAddLink={(callback) => (
          // TODO add permission
          <Link to="/translation/create" className="main_button ml-4">
            {"Add Translation"}
          </Link>
        )}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddLanguagePopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        loader={loader}
        pageLengthChange={setTranslationPageLength}
        noOfItems={total}
        disableBootstrap={true}
        searchPlaceholder="Search Translation ..."
      >
        {deleteModal && (
          <ConfirmationModal
            onClose={hideConfirmDialog}
            isOpen={deleteModal}
            onConfirm={handleRemoveItems}
          />
        )}
      </ListLayout>
      <CotationPopup
        open={cotationPopup.open}
        onClose={() => setCotationPopup({ open: false, documents: [] })}
        documents={cotationPopup.documents}
        transId={cotationPopup.transId}
      />
    </>
  );
}

const TranslationItem = ({
  translation,
  index,
  selectedItems,
  handleChange,
  handleAddPopUp,
  current_page,
  pageLength,
  checkPermission,
  onReviseQoute,
}) => {


  const getBackgroundStyle = (status) => {
    switch (status) {
      case "Cancelled":
      case "Client Cancelled":
      case "Quote Rejected":
        return { background: "#FFF0F0" };
      case "Translator Declined":
        return { background: "#F7C8C5" };
      case "Under Review":
        return { background: "#f1ebff" };
      case "New Request":
        return { background: "#FFF1D4" };
      case "Completed":
        return { background: "#D2D5D5" };
      case "Quote Sent":
        return { background: "#D6E4EC" };
      case "Quote Approved":
        return { background: "#EBFEED" };
      case "Quote Revised":
        return { background: "#f4e9ff" };
      case "Invoice Sent":
        return { background: "#DDE1FE" };
      case "Translators Invited":
        return { background: "#CBD1DC" };
      case "Assigned":
        return { background: "#DCEBFE" };
      default:
        return { background: "#ffffff" };
    }
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(translation?.status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission("Delete Translations") && (
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                data-value={translation.id}
                checked={selectedItems.includes(translation.id.toString())}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          )}
        </div>
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {checkPermission("Detail Translations") ?
          <Link
            to={`/translation/view/${translation?.id}`}
            style={{
              color: "#6F8DFF",
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: 500,
            }}
          >
            {translation?.transid}
          </Link> :
          translation?.transid
        }
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.accounts?.user?.name}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.language?.name}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {Array.isArray(translation.translation_target_languages)
          ? translation?.translation_target_languages
            .map((tl) => tl.language?.name)
            .join(", ")
          : ""}
      </td>

      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.requester_name}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.status}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.total_words_count}
      </td>
      {/* <td style={getBackgroundStyle(status)}>{translation.est_words_count}</td> */}
      <td style={getBackgroundStyle(translation?.status)}>
        ${translation?.total_amount}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {new Date(translation.created_at).toISOString().slice(0, 16).replace("T", " ")}
      </td>
    </tr>
  );
};

export default Translation;
